import { action, observable, computed } from 'mobx';
import { token } from '../libs/localStorage';
import _ from 'lodash';
// const markerGreen = require('../components/Map/marker-green.png');
// const markerYellow = require('../components/Map/marker-yellow.png');
// const markerRed = require('../components/Map/marker-red.png');

const markerGreen = '/markers/marker-green.png';
const markerYellow = '/markers/marker-yellow.png';
const markerRed = '/markers/marker-red.png';


export default class MapStore {
  transportLayer;

  @observable loadingMarkers = false;
  @observable stations = [];
  @observable stationStatus = '';
  @observable searchTag = '';
  @observable searchTags = [];
  @observable selectedMarker = null;

  @computed get stationsJson() {
    return this.stations.map((item) => ({
      id: item.id,
      name: item.name,
      latitude: item.latitude,
      longitude: item.longitude,
      marker: item.marker,
      max_station_time: item.max_station_time,
      max_station_timestamp: item.max_station_timestamp,
      meta_data: !!item.meta_data && item.meta_data.map(({ id, seq, name, value, flagged, caption, description }) => ({
        id, seq, name, value, flagged, caption, description
      })),
      parameters: !!item.parameters && item.parameters.map(({ parameter_id, series_id, series_name, symbol, value }) => ({
        parameter_id, series_id, series_name, symbol, value
      })),
      tags: !!item.tags && item.tags.map(({ id, name, description, provides_uniqueness, starred }) => ({
        id, name, description, provides_uniqueness, starred
      })),
      color: item.color,
      station_type_id: item.station_type_id,
      location_id: item.location_id
    }))
  }

  constructor(transportLayer) {
    this.transportLayer = transportLayer;
  }

  onMarkerOver = marker => this.selectedMarker = marker.id.split('-')[1];

  @action fetchMapMarkers() {
    this.loadingMarkers = true;
    return this.transportLayer.fetchAll()
      .then(action(items => {
        let stations = [];

        items.map(station => {
          if (!!+station.latitude && !!+station.longitude) {
            let marker;
            switch (station.color) {
              case 'GREEN':
                marker = markerGreen;
                break;
              case 'YELLOW':
                marker = markerYellow;
                break;
              case 'RED':
                marker = markerRed;
                break;
              default:
                marker = markerGreen;
            }
            stations.push(Object.assign({}, station, { marker }));
          }
        });
        this.loadingMarkers = false;
        this.stations = stations;
      })).catch(err => {
        this.loadingMarkers = false;
        return Promise.reject(err);
      });
  }

  @action onChangeSearchTag = e => {
    this.selectedMarker = null;
    this.searchTag = e.target.value;
  };
  @action onChangeSearchTags = tags => {
    this.selectedMarker = null;
    this.searchTags = tags;

    localStorage.setItem(token.getDecoded().id, JSON.stringify(tags));
  }
  @action onChangeStationStatus = e => {
    this.selectedMarker = null;
    this.stationStatus = e.target.value;
  };

  @computed get filteredStations() {
    return this.stations
      // .filter(station => !!station.longitude && !!station.latitude)
      // .filter(station => {
      //   if (this.stationStatus === '') {
      //     return true;
      //   }
      //   return station.color === this.stationStatus;
      // })
      .filter(station => {
        if (!station.longitude && !station.latitude) return false;
        if (this.stationStatus !== '' && station.color !== this.stationStatus) return false;
        if (this.searchTags.length === 0) return false;
        if (!station.tags || !station.tags.length) return false;

        if (!station.tags.find(tag => this.searchTags.includes(tag.name))) return false;

        // let stationTags = station.tags.map(item => item.name);
        // for(let i=0; i<this.searchTags.length; i++){
        //   if(stationTags.indexOf(this.searchTags[i]) === -1) return false;
        // }
        return true;

        // const stationTags = (station.tags && station.tags.map(tag => tag.name).join('--')) || '';
        // return stationTags.toLowerCase().indexOf(this.searchTag.toLowerCase()) !== -1;
      });
  }


}


// WEBPACK FOOTER //
// ./src/stores/MapStore.js